import { Text } from '@/components/ui/index.js';
import styles from './ActivityTabs.module.css';

const tabs = [
  { id: 'upcoming', label: 'Upcoming' },
  { id: 'history', label: 'History' },
];

/**
 * ActivityTabs - Tab switcher for Upcoming/History
 * 
 * Features:
 * - Two tabs: Upcoming and History
 * - Animated active indicator
 * - Tab content slide transition
 */
export function ActivityTabs({ activeTab, onTabChange }) {
  return (
    <div className={styles.tabsContainer}>
      <div className={styles.tabs}>
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`${styles.tab} ${activeTab === tab.id ? styles.active : ''}`}
            onClick={() => onTabChange(tab.id)}
            role="tab"
            aria-selected={activeTab === tab.id}
          >
            <Text
              size="base"
              weight={activeTab === tab.id ? 'semibold' : 'medium'}
              color={activeTab === tab.id ? 'primary' : 'muted'}
            >
              {tab.label}
            </Text>
          </button>
        ))}
        {/* Active Indicator */}
        <div
          className={styles.indicator}
          style={{
            transform: `translateX(${activeTab === 'upcoming' ? '0%' : '100%'})`,
          }}
        />
      </div>
    </div>
  );
}

export default ActivityTabs;
